import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator' ;


@Component
class Paginator extends Vue {

    dtDiff: number | null
    readonly dtTotalExceedLimit: number

    constructor(){ 
        super()
        this.dtDiff= null;
        this.dtTotalExceedLimit= 11;
    }

    @Prop({ default: 1, type: [Number] })
    total: number

    @Prop({ default: 0, type: [Number] })
    value: number

    handlePrevious(){
        var current= this.value
        this.coDiff= current
        if(current > 1) this.$emit('input',--current)
    }

    handeNext(){
        var current= this.value
        this.coDiff= current
        if(current < this.total ) this.$emit('input',++current)
    }

    handleBtnClick(page: number){
        this.coDiff= page
        this.$emit('input',page)
    }

    handleFirst(){
        this.coDiff= 1
        this.$emit('input',1)
    }

    handleLast(){
        this.coDiff= this.total
        this.$emit('input',this.total)
    }

    get coDiff():number{
        return this.dtDiff
    }

    set coDiff(current: number){
        if(current >= this.dtTotalExceedLimit ) this.dtDiff = current - this.dtTotalExceedLimit + 1
        else this.dtDiff= null
    }

    mounted() {
        this.coDiff= this.value
    }

}

export default Paginator


// WEBPACK FOOTER //
// ./src/components/paginator/index.ts